import { getApiGatewayBaseUrl, getAuthApiBaseUrl } from './authUrlConstants'
import { getPhoneRefreshTokenUrl } from './publicUrlConstants'

export const AUTH_API_PATHS = {
  requestOtp: '/send-otp-v2',
  verifyOtp: '/verify-otp-v2',
  sessionLogin: '/auth/login',
} as const

export const AUTH_API_URLS = {
  get authBase() {
    return getAuthApiBaseUrl()
  },
  get phoneRefreshToken() {
    return getPhoneRefreshTokenUrl()
  },
  get signup() {
    return `${getAuthApiBaseUrl()}/signup/buyer`
  },
  get logout() {
    return `${getAuthApiBaseUrl()}/logout`
  },
  get refreshToken() {
    return `${getAuthApiBaseUrl()}/refresh-token`
  },
  get refreshWhatsapp() {
    return `${getApiGatewayBaseUrl()}/auth/refresh-whatsapp`
  },
} as const
